const quickOrderSearch = () => ({
    query: '',
    currentIso: window.accuvars.language.iso_code,
    results: [],
    showResults: false,
    isActive: false,
    loading: false,
    keyboardNavigation: false,
    navigationSelectionIndex: 0,
    showResultsCount: 10,
    typingTimer: null,
    navigateResults(e) {
        const { length } = this.results
        const resultContainer = this.$refs.result_box

        if (e.which === 40) {
            if (this.navigationSelectionIndex + 1 !== length) {
                this.navigationSelectionIndex += 1
                resultContainer.scrollTo({
                    top: resultContainer.children[this.navigationSelectionIndex + 1].offsetTop,
                    behavior: 'smooth',
                })
            }
        }

        if (e.which === 38) {
            if (this.navigationSelectionIndex !== 0) {
                this.navigationSelectionIndex -= 1
                resultContainer.scrollTo({
                    top: resultContainer.children[this.navigationSelectionIndex].offsetTop,
                    behavior: 'smooth',
                })
            }
        }
    },
    searchWithAlgolia() {
        const queries = [
            {
                indexName: 'new_products',
                query: this.query,
                restrictSearchableAttributes: [
                    'manufacturer_name',
                    'reference',
                    `${this.currentIso}.title`,
                    `${this.currentIso}.meta_keywords`,
                    `${this.currentIso}.meta_description`,
                    `${this.currentIso}.category_name`,
                    `${this.currentIso}.attributes`,
                ],
                params: {
                    hitsPerPage: this.showResultsCount,
                },
            },
        ]

        window.api.search(queries).then((searchResults) => {
            if (searchResults.length === 0) {
                this.hits = 0
                this.results = []
            } else {
                const indexResult = searchResults[0]
                this.results = indexResult.hits
                this.loading = false
            }
            // reset selection afte search
            this.navigationSelectionIndex = 0
        }).catch(() => {
            this.results = []
            this.loading = false
        })
    },
    performSearch(event, dispatch) {
        if (this.query.length > 0) {
            this.loading = true
        }

        this.showResults = true
        this.isActive = true

        if (this.showResults === true && this.results && this.results.length > 0 && (event.which === 40 || event.which === 38)) {
            this.navigateResults(event)
            return true
        }

        if (this.showResults === true && this.results && this.results.length > 0 && event.which === 13) {
            this.query = this.results[this.navigationSelectionIndex].reference
            dispatch('item-selected', this.results[this.navigationSelectionIndex])
            this.showResults = false
            return true
        }

        // re-introducing timer and removing debounce, because debounce does not allow fast scrolling with arrows
        clearTimeout(this.typingTimer)
        this.typingTimer = setTimeout(() => {
            if (this.query.trim().length < 1) {
                this.results = []
                this.loading = false
                return true
            }

            this.searchWithAlgolia()
            return true
        }, 400)

        return true
    },
    movingAway() {
        this.isActive = false
        this.showResults = false
        return true
    },
    selectProduct(dispatch, product, index, el) {
        const inputElement = el.closest('.row_container').querySelector('.searcher')
        // if we clicked on the option , that means we lost focus, lets return focus back, so other events work
        // inputElement.focus()
        // set reference to query itself
        this.query = ''
        // set active row from selection
        this.navigationSelectionIndex = index
        this.showResults = false
        dispatch('item-selected', product)
        return true
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('quickOrderSearch', quickOrderSearch)
})
